// extracted by mini-css-extract-plugin
export default {"navLink":"AdminHome_navLink__SSYZ7"};